import {Component, Input} from '@angular/core';
import {CatalogRecord} from '@raven';

@Component({
  selector: 'rn-favorites-grid',
  templateUrl: './favorites-grid.component.html',
  styleUrl: './favorites-grid.component.scss',
  standalone: false
})
export class FavoritesGridComponent {
  @Input() items: Array<CatalogRecord>;
}
